var _g, _path, _g2, _path2, _path3, _path4, _g3, _path5, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArchivedProposalsEmptyState = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 205,
  height: 188,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_dd_40062_295482)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M179.354 73.792L104.514 53.9753C102.191 53.1041 98.906 53.7777 97.5456 55.1402L21.8893 131.203C21.4321 131.662 20.7148 131.913 20.6592 132.719C20.5524 134.267 22.575 137.314 24.0562 137.71L103.126 158.897C104.984 159.395 107.594 158.694 108.954 157.332L184.072 81.7318C186.087 79.1232 181.212 74.2899 179.354 73.792Z",
  fill: "url(#paint0_linear_40062_295482)"
}))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M178.499 73.5687L104.351 53.7006C101.15 52.843 96.6557 54.0472 94.3125 56.3903L21.9816 128.721C19.6384 131.064 20.3337 133.659 23.5345 134.517L95.7514 153.867C100.019 155.011 106.011 153.405 109.136 150.281L180.052 79.3643C182.396 77.0211 181.7 74.4264 178.499 73.5687Z",
  fill: "white"
})), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter1_f_40062_295482)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M109.721 151.717L180.49 79.6696C182.675 77.4451 182.144 74.9886 179.272 74.031L176.53 73.1171L104.913 54.2501C101.716 53.4079 97.2489 54.609 94.9109 56.9394L22.3522 129.262C20.0219 131.585 20.6766 134.163 23.8205 135.045L96.1767 155.334C100.473 156.538 106.589 154.905 109.721 151.717Z",
  fill: "url(#paint1_linear_40062_295482)"
}))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M178.499 73.5687L104.351 53.7006C101.15 52.843 96.6557 54.0472 94.3125 56.3903L21.9816 128.721C19.6384 131.064 20.3337 133.659 23.5345 134.517L95.7514 153.867C100.019 155.011 106.011 153.405 109.136 150.281L180.052 79.3643C182.396 77.0211 181.7 74.4264 178.499 73.5687Z",
  fill: "url(#paint2_linear_40062_295482)"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M61.4145 97.5912C62.2336 96.8502 63.7601 96.4906 64.8239 96.788L134.163 116.173C135.227 116.47 135.426 117.312 134.606 118.053L128.673 123.42C127.854 124.161 126.328 124.52 125.264 124.223L55.9243 104.838C54.8605 104.541 54.6622 103.699 55.4814 102.958L61.4145 97.5912Z",
  fill: "#F3F0FF"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M76.2389 81.1136C77.0581 80.3727 78.5845 80.0131 79.6483 80.3104L148.988 99.6951C150.052 99.9925 150.25 100.834 149.431 101.575L143.498 106.942C142.679 107.683 141.152 108.043 140.088 107.745L70.7488 88.3606C69.685 88.0632 69.4867 87.2214 70.3058 86.4804L76.2389 81.1136Z",
  fill: "#F3F0FF"
})), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter2_d_40062_295482)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M149.277 65.5028C145.652 69.1279 138.66 71.1494 133.659 70.0179C131.528 69.5357 130.103 68.5585 129.45 67.3152C127.507 63.8343 129.09 63.4855 131.17 61.4055C134.795 57.7805 141.787 55.759 146.787 56.8904C148.855 57.3583 149.984 56.9177 150.937 59.4831C151.583 61.2236 151.403 63.3769 149.277 65.5028Z",
  fill: "url(#paint3_linear_40062_295482)"
}))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M91.3572 124.562C91.1653 124.132 90.4789 123.961 89.8327 123.8L19.7123 106.388C18.8057 106.145 17.3101 106.682 16.1013 107.629C15.6426 107.988 15.2096 108.361 14.7008 108.694L9.87631 111.859C8.42595 113.019 9.43584 115.399 10.5096 115.687L81.9892 134.84C83.0633 135.128 84.9628 134.32 86.2339 133.036L90.8353 128.386C91.7813 127.43 91.7716 125.492 91.3572 124.562Z",
  fill: "#4926CD"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M90.6117 124.8L19.1321 105.647C18.0584 105.359 16.1584 106.167 14.8873 107.451L10.2859 112.101C9.01477 113.385 8.85558 114.659 9.92931 114.946L81.4089 134.099C82.483 134.387 84.3825 133.58 85.6537 132.295L90.2551 127.646C91.5262 126.361 91.6858 125.088 90.6117 124.8Z",
  fill: "#6942F8"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  d: "M31.7889 114.631L30.5246 115.346L29.5355 115.081L35.5406 111.741L36.6302 112.033L34.8288 116.5L33.8165 116.228L34.2153 115.281L31.7889 114.631ZM34.513 114.572L35.3384 112.62L32.7357 114.096L34.513 114.572ZM40.0901 115.019L39.9433 114.98C39.562 114.877 39.1815 114.876 38.8016 114.975C38.4268 115.075 38.1055 115.259 37.8378 115.527L36.4349 116.93L35.5694 116.698L38.4544 113.813L39.3199 114.045L38.8956 114.469C39.1959 114.359 39.4886 114.291 39.7739 114.267C40.0681 114.241 40.3414 114.261 40.5938 114.329L40.7406 114.368L40.0901 115.019ZM40.2419 118.036C39.8452 117.93 39.5506 117.767 39.358 117.548C39.1706 117.331 39.0992 117.082 39.1438 116.802C39.1935 116.524 39.3598 116.243 39.6427 115.961C39.9255 115.678 40.2721 115.445 40.6825 115.264C41.098 115.083 41.5314 114.97 41.9828 114.924C42.4393 114.879 42.866 114.909 43.2626 115.015C43.649 115.119 43.9378 115.278 44.129 115.491C44.3201 115.705 44.3946 115.948 44.3524 116.218L43.2691 116.351C43.2967 116.187 43.2574 116.04 43.1511 115.911C43.0448 115.782 42.8784 115.687 42.6517 115.626C42.425 115.566 42.1768 115.549 41.907 115.577C41.6423 115.607 41.3861 115.677 41.1384 115.788C40.8996 115.896 40.6973 116.033 40.5313 116.199C40.3654 116.365 40.2642 116.531 40.2277 116.698C40.2001 116.863 40.2394 117.01 40.3457 117.139C40.4571 117.269 40.6261 117.365 40.8528 117.425C41.0795 117.486 41.3251 117.502 41.5898 117.472C41.8545 117.443 42.1088 117.375 42.3527 117.268L42.7685 117.802C42.3657 117.977 41.9405 118.085 41.4929 118.128C41.0452 118.17 40.6282 118.14 40.2419 118.036ZM48.0799 116.306C48.5487 116.432 48.8211 116.636 48.897 116.92C48.9781 117.204 48.847 117.518 48.5039 117.862L46.688 119.677L45.8225 119.446L47.4291 117.839C47.6516 117.616 47.7387 117.415 47.6904 117.235C47.651 117.052 47.4819 116.921 47.1831 116.841C46.8688 116.756 46.5466 116.759 46.2165 116.847C45.8901 116.932 45.6157 117.085 45.3932 117.308L43.798 118.903L42.9325 118.671L47.0054 114.598L47.8709 114.83L46.2926 116.408C46.9226 116.19 47.5184 116.156 48.0799 116.306ZM51.569 116.71C51.4145 116.669 51.3208 116.596 51.2881 116.492C51.2643 116.385 51.3089 116.275 51.422 116.162C51.5389 116.045 51.6866 115.962 51.8651 115.915C52.0487 115.868 52.2178 115.866 52.3723 115.907C52.532 115.95 52.6257 116.023 52.6533 116.126C52.686 116.23 52.644 116.341 52.5271 116.458C52.4139 116.571 52.2637 116.653 52.0763 116.703C51.8978 116.751 51.7287 116.753 51.569 116.71ZM50.6498 117.081L51.5153 117.313L48.6303 120.198L47.7648 119.966L50.6498 117.081ZM51.9076 121.076L51.0112 120.836L52.2194 117.502L53.2085 117.767L52.2478 120.177L55.5035 118.381L56.4695 118.64L51.9076 121.076ZM59.4032 121.263C59.3165 121.349 59.2258 121.43 59.1312 121.505L55.9397 120.65C55.8044 120.877 55.7879 121.083 55.8901 121.268C55.9923 121.453 56.2031 121.589 56.5225 121.674C56.7698 121.74 57.0368 121.764 57.3234 121.745C57.6101 121.727 57.8692 121.676 58.1008 121.595L58.3204 122.12C57.9258 122.253 57.5185 122.331 57.0987 122.352C56.684 122.375 56.2938 122.337 55.928 122.239C55.5159 122.129 55.2084 121.963 55.0055 121.741C54.8078 121.521 54.7287 121.27 54.7681 120.989C54.8165 120.705 54.984 120.42 55.2706 120.134C55.5497 119.855 55.8944 119.624 56.3047 119.443C56.7202 119.262 57.1492 119.15 57.5917 119.106C58.0431 119.06 58.462 119.088 58.8483 119.192C59.2398 119.297 59.5267 119.457 59.709 119.673C59.8912 119.89 59.9575 120.137 59.9078 120.415C59.858 120.693 59.6898 120.976 59.4032 121.263ZM58.7475 120.743C58.8842 120.521 58.9072 120.322 58.8167 120.144C58.7351 119.965 58.5526 119.837 58.2693 119.761C57.9911 119.686 57.6867 119.684 57.3562 119.753C57.0295 119.818 56.7282 119.943 56.4524 120.128L58.7475 120.743ZM62.8 123.995L61.9345 123.763L62.3475 123.35C62.028 123.46 61.7083 123.525 61.3884 123.545C61.0684 123.564 60.7668 123.536 60.4835 123.46C60.1177 123.362 59.8514 123.207 59.6846 122.995C59.523 122.784 59.4722 122.541 59.5322 122.265C59.5974 121.991 59.7714 121.713 60.0543 121.43C60.3371 121.147 60.676 120.913 61.0709 120.727C61.4709 120.542 61.8838 120.423 62.3094 120.37C62.7402 120.318 63.1384 120.341 63.5042 120.439C63.7875 120.515 64.0062 120.626 64.1602 120.773C64.3142 120.919 64.3964 121.092 64.4066 121.291L66.0075 119.69L66.8729 119.922L62.8 123.995ZM60.9429 121.668C60.777 121.834 60.6758 122 60.6392 122.168C60.6117 122.332 60.651 122.479 60.7573 122.608C60.8635 122.737 61.0326 122.832 61.2644 122.895C61.4911 122.955 61.7367 122.971 62.0014 122.941C62.266 122.912 62.5178 122.843 62.7566 122.735C63.0043 122.624 63.2111 122.486 63.377 122.32C63.543 122.154 63.6397 121.989 63.6673 121.824C63.7038 121.657 63.6689 121.509 63.5627 121.38C63.4564 121.251 63.2899 121.156 63.0633 121.096C62.8315 121.034 62.5832 121.017 62.3186 121.047C62.0539 121.076 61.7977 121.146 61.55 121.257C61.3112 121.365 61.1088 121.502 60.9429 121.668Z",
  fill: "#FCFCFD"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_dd_40062_295482",
  x: 0.655029,
  y: 23.585,
  width: 203.896,
  height: 163.473,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: -10
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 10
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.564323 0 0 0 0 0.513021 0 0 0 0 0.820833 0 0 0 0.04 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_40062_295482"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 8
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 10
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.156863 0 0 0 0 0.117647 0 0 0 0 0.352941 0 0 0 0.21 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect1_dropShadow_40062_295482",
  result: "effect2_dropShadow_40062_295482"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect2_dropShadow_40062_295482",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter1_f_40062_295482",
  x: 19.9568,
  y: 52.9812,
  width: 162.877,
  height: 103.749,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5,
  result: "effect1_foregroundBlur_40062_295482"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter2_d_40062_295482",
  x: 108.568,
  y: 40.5764,
  width: 62.6985,
  height: 53.7556,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 4
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 10
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.411765 0 0 0 0 0.258824 0 0 0 0 0.972549 0 0 0 0.12 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_40062_295482"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_40062_295482",
  result: "shape"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_40062_295482",
  x1: 185.79,
  y1: 72.549,
  x2: 12.445,
  y2: 30.2741,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#8B98DE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.200284,
  stopColor: "#C1CBFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.303741,
  stopColor: "#E9ECFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.310958,
  stopColor: "#DDE2FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.333069,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.491969,
  stopColor: "#CED6FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.857402,
  stopColor: "#94A0E3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#DAE0FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_40062_295482",
  x1: 184.942,
  y1: 68.1858,
  x2: -144.761,
  y2: 494.955,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear_40062_295482",
  x1: 184.362,
  y1: 67.6054,
  x2: -145.341,
  y2: 494.375,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear_40062_295482",
  x1: 156.328,
  y1: 58.5636,
  x2: 146.515,
  y2: 46.4705,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.325361,
  stopColor: "#FCFCFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E7EAF8"
})))));
export default SvgArchivedProposalsEmptyState;